<template>
  <div class="mnewsinfo">
    <div class="mnicon">
      <p class="mtitle">{{ nownews.title }}</p>
      <div class="author">
        <p>作者:{{ nownews.author }}</p>
        <p>发布时间:{{ nownews.createTime }}</p>
      </div>
      <div class="mline"></div>
      <div class="infocontent">
        <div ref="reportHTML" v-html="htmlText" class="webcon"></div>
      </div>
    </div>
    <div class="mtools">
      <div class="toolsleft">
        <div class="toolsingle" @click="changeinfo(prev)">
          <i
            class="el-icon-arrow-left"
            style="font-size: 5.33vw; height: 5.33vw"
          ></i>
          <p style="font-size: 3.2vw; line-height: 5.87vw; height: 5.33vw">
            上一篇
          </p>
        </div>
        <div class="toolsingle" @click="changeinfo(next)">
          <p style="font-size: 3.2vw; line-height: 5.87vw; height: 5.33vw">
            下一篇
          </p>
          <i
            class="el-icon-arrow-right"
            style="font-size: 5.33vw; height: 5.33vw"
          ></i>
        </div>
      </div>
      <div class="toolsright" @click="backist">
        <p style="font-size: 3.2vw; height: 5.33vw; line-height: 6vw">
          返回列表
        </p>
        <img
          src="../../assets/image/mback.png"
          alt=""
          style="width: 5.33vw; height: 5.33vw"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sendnews: {},
      nownews: {},
      prev: {},
      next: {},
      lefthover: 0,
      righthover: 0,
      htmlText: "",
      list: [],
      from: "",
    };
  },
  methods: {
    backist() {
      this.$router.go(-1);
    },
    changeinfo(e) {
      if (!e.id) {
        console.log("没有更多了");
        return;
      } else {
        for (let i in this.list) {
          i = Number(i);
          if (e.id == this.list[i].id) {
            this.nownews = this.list[i];
            this.htmlText = this.nownews.content;
            document.getElementsByTagName("html")[0].scrollTop = 0;
            if (this.list[i - 1]) {
              this.prev = this.list[i - 1];
            } else {
              this.prev = { title: "没有了" };
            }
            if (this.list[i + 1]) {
              this.next = this.list[i + 1];
            } else {
              this.next = { title: "没有了" };
            }
          }
        }
      }
    },
  },
  async created() {
    this.sendnews = this.$route.query;
    console.log(this.$route);
    let res = await this.$http.newslist(this.sendnews);
    this.list = res.data;
    if (res.code == 200) {
      for (let i in res.data) {
        i = Number(i);
        if (this.sendnews.id == res.data[i].id) {
          this.nownews = res.data[i];
          this.htmlText = this.nownews.content;
          if (res.data[i - 1]) {
            this.prev = res.data[i - 1];
          } else {
            this.prev = { title: "没有了" };
          }
          if (res.data[i + 1]) {
            this.next = res.data[i + 1];
          } else {
            this.next = { title: "没有了" };
          }
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
.mnewsinfo {
  .infocontent {
    width: 100%;
    padding: 1.04vw 5.21vw 0 5.21vw;
    font-size: 16px;
    font-weight: normal;
    line-height: 30px;
    color: rgba(18, 20, 58, 0.65);
  }
  .mtools {
    .toolsright {
      width: 25.07vw;
      height: 100%;
      background: #fff;
      padding: 2.4vw 2.67vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .toolsleft {
      .toolsingle {
        width: 24vw;
        height: 100%;
        background: #fff;
        padding: 2.67vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      width: 51.2vw;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-content: center;
    }
    width: 100%;
    height: 10.67vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mnicon {
    .mline {
      width: 100%;
      height: 0.27vw;
      background: rgba(216, 216, 216, 1);
      margin-bottom: 4vw;
    }
    .author {
      width: 49.07vw;
      height: 5.87vw;
      margin-bottom: 2.67vw;
      font-size: 3.2vw;
      color: rgba(6, 25, 45, 0.45);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .mtitle {
      font-size: 4.27vw;
      font-weight: 500;
      color: #06192d;
      margin-bottom: 1.6vw;
    }
    padding: 4vw 3.2vw;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 4vw;
  }
  padding: 5.33vw;
  background: url("../../assets/image/newsinfobg.png");
  background-position: 0 0;
  background-size: 100% 100%;
}
</style>
